<template>
    <div>
        <div id="refill_wrapper"
            :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
            <div id="refill_content">
                <div v-if="group == 4">
                    <div class="refill-txt" v-html="lbl.serial.refill_line_1"></div>
                    <div class="refill-txt" v-html="lbl.serial.refill_line_2"></div>
                </div>
                <div v-else>
                    <div class="refill-txt" v-html="lbl.serial.refill_group_8"></div>
                </div>
                    <TertiaryButton
                        btnId="refill_btn"
                        :btnMsg="lbl.serial.refill_btn"
                        @clickButton="clickRefillInformation()" />
            </div>
        </div>
    </div>
</template>
<script>
import TertiaryButton from "../../../Button/TertiaryButton.vue";
export default {
    name: 'SerialRefillInfo',
    components: {
        TertiaryButton
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        lbl: Object,
        controller: Object,
        group: String
    },
    methods: {
        //event
        clickRefillInformation: function () {
            this.$emit('clickRefillInformation');
        }
    }
}
</script>
<style lang="scss">
#refill_btn {
    width: 75%;
    min-height: 30px;
    height: 30px;

    .btn-txt {
        font-size: 1.25rem;
        // font-family: "Heading";
        // letter-spacing: 0.5px;
    }
}
</style>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
#refill_wrapper {
    margin-top: 5px;
    padding: {
        left: 25px;
        right: 25px;
    }

    #refill_content {
        padding: {
            top: 30px;
            bottom: 10px;
        };
        border-top: 1px solid rgba(#707070, 0.2);
    }

    .refill-txt {
        margin-bottom: 15px;
        font-size: 1.5rem;
        // font-family: $heading;
        // line-height: 1;
        text-align: center;

        &:nth-child(2) {
            margin-bottom: 25px;
        }
    }
}
</style>
